// 全站模块
const Site = {
  state: {
    siteName: 'www.projectWeb.com',
    language: "origin", // 当前翻译用语言
  },

  mutations: {
    // 更新当前翻译用语言
    updataLanguage(state, payload) {
      state.language = payload
    }
  },
  getters: {}
}

export default Site
